import React from "react";
import dayjs from "dayjs";

interface Props {
  dateString: string;
}

const NotificationTimeLabel: React.FC<Props> = ({ dateString }) => {
  const date = dayjs(dateString);
  const now = dayjs();
  const yesterday = dayjs().subtract(1, "day");

  let result = "";

  // Today → show relative time
  if (date.isSame(now, "day")) {
    const diffMinutes = now.diff(date, "minute");
    const diffHours = now.diff(date, "hour");

    if (diffMinutes < 1) {
      result = "<1 minute"; // Just now
    } else if (diffMinutes < 60) {
      result = `${diffMinutes}m`;
    } else {
      result = `${diffHours}h`;
    }
  }
  // Yesterday
  else if (date.isSame(yesterday, "day")) {
    result = "Yesterday";
  }
  // Older
  else {
    result = date.format("DD/MM/YYYY hh:mm A");
  }

  return <>{result}</>;
};

export default NotificationTimeLabel;
